import { useSyncExternalStore } from 'react';

const subscribe = (callback: () => void) => {
  window.addEventListener('resize', callback);
  return () => window.removeEventListener('resize', callback);
};

const getSnapshot = () => document.documentElement.clientHeight;

const getServerSnapshot = () => 0;

export function useClientHeight() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
